module.exports = __webpack_public_path__ + "img/half_blood_princes_book.03eadcab.jpg";